var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarehouseDedicated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 32,
    viewBox: "0 0 29 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_206_25305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 21.8292V10.1711C29 8.61889 28.1714 7.18605 26.8195 6.41536L16.6805 0.58632C15.3286 -0.184372 13.6714 -0.184372 12.3195 0.58632L2.18045 6.41536C0.828571 7.18605 0 8.61889 0 10.1711V21.8292C0 23.3814 0.828571 24.8143 2.18045 25.585L12.3195 31.414C13.6714 32.1847 15.3286 32.1847 16.6805 31.414L26.8195 25.585C28.1714 24.8143 29 23.3814 29 21.8292Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_206_25305"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouseDedicated);
export default __webpack_public_path__ + "static/media/warehouse-dedicated.8e8970880b3d30832e288af4aef391bc.svg";
export { ForwardRef as ReactComponent };